@if (opened()) {
  <div class="host">
    <div class="drawer-container" >
      <div class="overlay" (click)="opened.set(false)">

      </div>
      <div class="drawer"
           #drawer
           [class.drawer-right]="position() === 'right'"
           [class.drawer-left]="position() === 'left'">
        <ng-content></ng-content>
      </div>
    </div>

  </div>

}


